import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { StoreGroupStore } from "models/dbModels/storeGroups/StoreGroupStores";
import { StoreGroupStoresFilterQuery } from "models/filters/storeGroupStores/StoreGroupStoresFilterQuery";

export class StoreGroupStoresApi {
    static Search = async (query: StoreGroupStoresFilterQuery) => axios.post<PaginatedResponse<StoreGroupStore[]>>(`api/v1/StoreGroupStores/Search`, query);
    static Update = async (query: StoreGroupStore[]) => axios.post<DataResponse<boolean>>(`api/v1/StoreGroupStores/Update`, query);
    static DeleteThenAddOrEdit = async (query: StoreGroupStore[]) => axios.post<DataResponse<boolean>>(`api/v1/StoreGroupStores/DeleteThenAddOrEdit`, query);
    static DeleteByGroup = async (ids: number[]) => axios.delete<DataResponse<boolean>>(`api/v1/StoreGroupStores/DeleteByGroup`, { data: ids });
}